<template>
  <img class="escalon-absolute-center" src="../../assets/INF.png" title="Image Not Found" />
</template>

<script>
export default {
  name: "imageNotFound"
}
</script>